import { useEffect, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import OrdersBar from "../../components/marketplace/OrdersBar";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import PageMain from "../../containers/shared/PageMain";
import Loading from "../../components/shared/Loading";
import apiClient from "../../components/utils/apiClient";
import OrdersTable from "../../components/marketplace/OrdersTable";
import Pagination from "../../components/shared/Pagination";
import { Link, useSearchParams } from "react-router-dom";

const MarketPlaceOrdersPage = () => {

    useDocumentTitle('الطلبات');
    const pageTitle = {title: 'الطلبات', subTitle: ''};
    const [total,setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage,setCurrentPage] = useState(1);
    const [orders,setOrders] = useState(null);
    const [closeAllModals, setCloseAllModals] = useState(false);
    const [isLoading, setIsLoading] = useState(()=>true);
    const [refreshWallet, setRefreshWallet] = useState(()=>new Date().getTime());

    const [isEmpty, setIsEmpty] = useState(true);
    
    const [searchParams] = useSearchParams();
    const querySearch = searchParams.get('search') || "";

    useEffect(() => {
        if (querySearch.length > 0 && querySearch.length < 3) {
        return;
        }

        const delayDebounceFn = setTimeout(() => {
        getOrders(1, querySearch);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [querySearch]);

    const getOrders = async (page=1, searchTerm = "") => {

      let url = `/orders/business-orders?skip=${(page-1)*pageSize}&limit=${pageSize}`;
      
      if (searchTerm && searchTerm.length >= 3) {
        url += `&orderPrettyId=${encodeURIComponent(searchTerm)}`;
      }
      try {
        const response = await apiClient.get(url);
        if(response?.data) {
          setOrders(response?.data);
          setIsLoading(false);
          setCurrentPage(page);
          const previousTotal = pageSize*(page-1);
          setTotal(previousTotal + response?.data?.length);
          if(response?.data?.length > 0) {
            setIsEmpty(false);
          }
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        getOrders();
    },[])

    const handleChangePageAction = (page) =>{
        getRequests(page);
    }

    const handleRefreshRequests = () => {
        getOrders(currentPage);
        setTimeout(()=>setRefreshWallet(new Date().getTime()),500);
    }

    return (
        <>
        <PageHeader key={refreshWallet} pageTitle={pageTitle} isColored />
            <PageMain>
                <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
                <MainContent>
                    <OrdersBar requestsCount={orders?.length} />
                    {orders !== null && Array.isArray(orders) && orders?.length < 1 && !querySearch && !isEmpty && <Loading showLoading={true} />}
                    {orders !== null && Array.isArray(orders) && orders?.length < 1 && !querySearch && isEmpty && 
                        <div className="pt-[100px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/note.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بإضافة أي طلب حتى الآن</div>
                            <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={'/ar/marketplace'}>أضف طلب جديد</Link>
                        </div>
                    }
                    {orders !== null && Array.isArray(orders) && orders?.length < 1 && querySearch &&
                        <div className="pt-[80px] text-center">
                        <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/note.svg')"}}></div>
                        <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لايوجد طلبات مطابقة بهذا الرقم</div>
                        {/* <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to="/ar/users/add">أضف مستخدم جديد</Link> */}
                        </div>
                    }
                    {orders && Array.isArray(orders) && orders?.length > 0 
                    && <>
                        <OrdersTable requests={orders} type="main" closeAllModals={closeAllModals} currentPage={currentPage} pageSize={pageSize} setIsLoading={setIsLoading} handleRefreshRequests={handleRefreshRequests} />
                        <Pagination label={'طلب'} total={total} currentPage={currentPage} pageSize={pageSize} handleClickChangePage={page => handleChangePageAction(page)} />
                        </>
                    }
                </MainContent>
        </PageMain>
        {isLoading && <Loading showLoading={true} />}
        </>
    )
}

export default MarketPlaceOrdersPage